/* @flow */
import React, { Component } from 'react';
import {
  graphql,
  createPaginationContainer,
  type RelayPaginationProp,
} from 'react-relay';
import { List } from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';

import StudentJobSessionBooked from './StudentJobSessionBooked';
import type { StudentBooked_student } from './__generated__/StudentBooked_student.graphql';

type Props = {
  student: StudentBooked_student,
} & RelayPaginationProp;

type State = {
  error: ?Error,
};

class StudentBooked extends Component<Props, State> {
  state = {
    error: null,
  };

  handleLoadMore = () => {
    if (!this.props.relay.hasMore() || this.props.relay.isLoading()) {
      return;
    }

    this.props.relay.loadMore(
      10, // Fetch the next 10 feed items
      error => {
        this.setState({ error });
      }
    );
  };

  render() {
    const { student: { jobSessions } } = this.props;
    const { error } = this.state;

    return (
      <div>
        {error && error.message}
        {jobSessions && jobSessions.edges.length > 0 ? (
          <List>
            {jobSessions.edges.map(
              edge =>
                edge &&
                edge.node && (
                  <StudentJobSessionBooked
                    key={edge.node.id}
                    session={edge.node}
                  />
                )
            )}
          </List>
        ) : (
          <div style={{ padding: 10 }}>No Job Sessions Found</div>
        )}

        <RaisedButton
          label="Load More"
          disabled={
            jobSessions &&
            jobSessions.pageInfo &&
            !jobSessions.pageInfo.hasNextPage
          }
          fullWidth
          secondary
          onClick={this.handleLoadMore}
        />
      </div>
    );
  }
}

export default createPaginationContainer(
  StudentBooked,
  {
    student: graphql`
      fragment StudentBooked_student on Student {
        jobSessions(
          first: $bookedCount
          after: $bookedCursor
          status: [Started]
        ) @connection(key: "StudentBooked_jobSessions") {
          edges {
            node {
              id
              ...StudentJobSessionBooked_session
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `,
  },
  {
    direction: 'forward',
    getConnectionFromProps(props) {
      return props.student && props.student.history;
    },
    // This is also the default implementation of `getFragmentVariables` if it isn't provided.
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, { count, cursor } /* , fragmentVariables */) {
      return {
        count,
        cursor,
        nodeId: props.nodeId,
      };
    },
    query: graphql`
      query StudentBookedPaginationAdminQuery(
        $bookedCursor: String
        $bookedCount: Int
        $nodeId: ID!
      ) {
        student: node(id: $nodeId) {
          ...StudentBooked_student
        }
      }
    `,
  }
);



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/StudentBooked.js